'use client';

import { PropsWithChildren } from 'react';
import { IconArrowSquareDown } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
type Props = PropsWithChildren & {
  title: string;
  uniqueKey: string;
  className?: string;
  hasFocusStyle?: boolean;
};
function TextExpandablePanel({
  children,
  title,
  uniqueKey,
  className,
  hasFocusStyle
}: Props) {
  return <div className={cn('relative flex h-fit w-full flex-wrap items-center border-b border-border-gray-light p-2', className, hasFocusStyle && 'has-[input:not(:checked)]:border-none has-[input:not(:checked)]:bg-surface-solid-50', hasFocusStyle && 'has-[input:checked]:border has-[input:checked]:bg-surface-solid-100')} data-sentry-component="TextExpandablePanel" data-sentry-source-file="index.tsx">
            <input type='checkbox' className='peer hidden' id={uniqueKey} name='faqs' />

            <label htmlFor={uniqueKey} className='flex grow cursor-pointer items-center justify-between text-body-14 peer-checked:mb-2 lg:text-body-16 peer-checked:[&>svg]:rotate-180'>
                <span className='py-2'>{title}</span>
                <IconArrowSquareDown className='h-6 w-6 min-w-6 transition-all duration-500' data-sentry-element="IconArrowSquareDown" data-sentry-source-file="index.tsx" />
            </label>

            <div className={cn('hidden w-full text-caption-12 peer-checked:flex lg:text-body-14', hasFocusStyle && 'text-text-darkGray')}>
                {children}
            </div>
        </div>;
}
export default TextExpandablePanel;